import React, { useState,useEffect } from "react";
import styles from "./NewUserInformation.module.css";
import ModalBlackBgTemplate from "../ModalBlackBgTemplate/ModalBlackBgTemplate";
import { ReactComponent as BudgerNewUserIcon } from "../../assets/BudgerNewUserIcon.svg";
import { ReactComponent as ContactNewUserIcon } from "../../assets/ContactNewUserIcon.svg";
import { ReactComponent as PurschaseInvoiceNewUserIcon } from "../../assets/PurschaseInvoiceNewUserIcon.svg";
import { ReactComponent as ProductsNewUserIcon } from "../../assets/ProductsNewUserIcon.svg";
import HeaderCard from "../HeaderCard/HeaderCard";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { finishTutorial } from "../../../../actions/user";
import { setTutorialAgain } from "../../../../slices/userSlices";
const NewUserInformation = () => {
  const { user, tutorialAgain } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { t } = useTranslation("navbarAdmin");
  const navigate = useNavigate();


  useEffect(()=>{
    tutorialAgain && setIsOpen(true)
    setIsOpen(true)
  },[tutorialAgain])

  

  const [step, setStep] = useState(0);
  const [isOpen, setIsOpen] = useState(true);

  const steps = [
    {
      icon: <BudgerNewUserIcon />,
      title: t('budgetTitle'),
      description: t('budgetDesc'),
      linkText: t('budgetLinkText'),
      linkHref: "/admin/asset",
    },
    {
      icon: <ContactNewUserIcon />,
      title: t('contacts'),
      description: t('contactsDesc'),
      linkText: t('contactlinkText'),
      linkHref: "/admin/contactos",
    },
    {
      icon: <PurschaseInvoiceNewUserIcon />,
      title: t('purschaseInvoiceTitle'),
      description: t('purschaseInvoiceDesc'),
      linkText: t('purschaseInvoiceLinkText'),
      linkHref: "/admin/contacts",
    },
    {
      icon: <ProductsNewUserIcon />,
      title: t('productTitle'),
      description: t('productDesc'),
      linkText: t('productLinkText'),
      linkHref: "/admin/productos",
    },
  ];
  const close = () => setIsOpen(false);

  const finishTutorialFn = async () => {
    const res = await dispatch(finishTutorial());
    dispatch(setTutorialAgain(false))
    close();
  };
  
  const nextStep = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
        finishTutorialFn();
    }
  };

  
  const current = steps[step];
  
  if (!isOpen) return null;
  if (user?.finishTutorial === true && !tutorialAgain) return null;

  return (
    <ModalBlackBgTemplate
      close={finishTutorialFn}
      customStyle={{
        maxHeight: "fit-content",
        minHeight: "fit-content",
        width: "600px",
        textAlign: "center",
      }}
    >
      <HeaderCard 
      setState={finishTutorialFn}
      title={t('tutorialTitle')}
      />
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <div className={styles.iconContainer}>{current.icon}</div>
          <h2>{current.title}</h2>
          <p>{current.description}</p>
          <div className={styles.btnContainer}>
            <Button
              action={() => navigate(current.linkHref)}
              headerStyle={{ fontWeight: "bold" }}
            >
              {current.linkText}
            </Button>
            <Button
              action={nextStep}
              type="white"
              headerStyle={{ color: "#119977", fontWeight: "bold" }}
            >
              {step === steps.length - 1 ? t('close') : t('next')}
            </Button>
          </div>
        </div>
      </div>
    </ModalBlackBgTemplate>
  );
};

export default NewUserInformation;
